import { render, staticRenderFns } from "./ManageCompanyProfile.vue?vue&type=template&id=6227e026"
import script from "./ManageCompanyProfile.vue?vue&type=script&lang=js"
export * from "./ManageCompanyProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports